import { File } from "@prisma/client";
import { IKImage } from "imagekitio-react";

export interface HumanOwnProps {
  image?: File | null;
  name: string;
  role: string;
  summary: string;
}

export function Human({ image, name, role, summary }: HumanOwnProps) {
  return (
    <div className="relative h-full">
      <div className="rounded overflow-hidden shadow-md bg-white pb-5 h-full">
        {!!image && (
          <div className={"absolute -mt-20 w-full flex justify-center"}>
            <div className="h-32 w-32">
              <IKImage
                path={image.url}
                alt={image.alt}
                className="rounded-full object-cover h-full w-full shadow-md"
                transformation={[{ height: 256, width: 256 }]}
                loading="lazy"
                lqip={{ active: true }}
              />
            </div>
          </div>
        )}
        <div className="px-6 mt-16">
          <h1 className="font-bold text-primary-900 text-3xl text-center mb-1">
            {name}
          </h1>
          <p className="text-primary-400 text-sm text-center">{role}</p>

          {summary ? (
            <details className="details-ellipsis text-center text-gray-500 hover:text-gray-800 hover:underline cursor-pointer text-base my-3 font-normal open:hover:text-gray-500 open:hover:no-underline open:cursor-default">
              <summary className="hover:underline">
                {summary.split(" ").slice(0, 20).join(" ")}
              </summary>
              {summary.split(" ").slice(20).join(" ")}
            </details>
          ) : null}

          {!!image?.copyright && (
            <p className="text-center text-gray-400 my-3 text-xs">
              Bildrechte: © {image.copyright}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
